<template>
  <BaseDialog
    data-test-id="dialogDeviceAlert"
    :title="t('dialogs.headers.deviceAlert')"
    v-model="store.showDeviceAlert"
    v-bind="$attrs"
    :max-width="500"
    icon="mdi-alert"
    icon-color="red"
  >
    <p>
      {{ t('warnings.deviceExpiration', store.devicesExpirations.length) }}
      {{ t('warnings.deviceExpirationSuffix') }}
    </p>

    <template v-slot:actions>
      <ButtonSecondary @click="store.cancelDeviceAlert" :text="t('buttons.cancel')" />
      <v-spacer />
      <ButtonPrimary @click="store.gotoDevices" :text="t('buttons.yes')" />
    </template>
  </BaseDialog>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { useAppStore } from '@/stores/ui/AppStore'
import { useI18n } from 'vue-i18n'

const store = useAppStore()
const { t } = useI18n({ useScope: 'global' })

// PROPS & EMITS

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
</script>
